import SeatPlaque from "./SeatPlaque";

function Seat(props) {
  const { plaque, height, text, sold } = { ...props };
  return (
    <div
      style={{
        display: "inline-block",
        border: "1px solid black",
        margin: "2px",
        width: 5 * height,
        minWidth: 5 * height,
        height: 3 * height + 4,
        minHeight: 3 * height + 4,
        background: "#515f6e",
        verticalAlign: "bottom",
      }}
    >
      <div style={{ mihHeight: 2 * height, height: 2 * height }}></div>
      <div
        style={{
          minHeight: height + 4,
          height: height + 4,
          width: 5 * height,
          alignContent: "center",
          textAlign: "center",
          margin: "auto",
          backgroundColor: "#928670",
        }}
      >
        {plaque ? (
          <SeatPlaque
            active={true}
            sold={sold}
            height={height}
            text={sold ? text : <span>Your name here!</span>}
          />
        ) : null}
      </div>
    </div>
  );
}

import { rows } from "./data";
export default function Auditorium(props) {
  const { scale } = { ...props };

  return (
    <div style={{ transform: `scale(${scale})`, transformOrigin: "0 0" }}>
      {rows.map((r, m) => (
        <div key={m} style={{}}>
          {r.map((c, n) => (
            <div
              key={n}
              style={{
                display: "inline-block",
                alignContent: "end",
                height: "100%",
              }}
            >
              <Seat
                sold={c.sold}
                plaque={c.plaque}
                key={n}
                text={c.text}
                height={20}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
